
import React from "react";
import { motion } from "framer-motion";
import StickyNavbar from "../navbar";

const Chapter5Questions = () => {
  const questions = [
    "What are the different approaches to research methods?",
    "How does qualitative research help in understanding health issues?",
    "What are the advantages of quantitative research in public health?",
    "What is the significance of using mixed methods"
  ];

  return (
    <div>
      <StickyNavbar />
      <div className="bg-gray-50 min-h-screen p-8 mt-10">
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-8"
        >
          <h1 className="text-3xl font-bold text-blue-900">
            Chapter 1 Questions
          </h1>
        </motion.div>
        <motion.ul
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="space-y-4 text-lg"
        >
          {questions.map((question, index) => (
            <motion.li
              key={index}
              whileHover={{ scale: 1.05, x: 10 }}
              className="bg-white shadow-md p-4 rounded-lg border border-gray-200"
            >
              {index + 1}. {question}
            </motion.li>
          ))}
        </motion.ul>
      </div>
    </div>
  );
};

export default Chapter5Questions;
